import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { routes } from '@model/constants/routes';
import { getHttpHeaders } from '@commons/utility/util';
import { map } from 'rxjs/operators';
import { CustomResponseDto } from '@core/model/custom-response-dto';
import { InitialProductValidationResponse } from '@model/InitialProductValidationResponse';
import { AMOUNT_BY_DEFAULT_CONSTANT, TERM_BY_DEFAULT_CONSTANT } from '@shared/configs';

@Injectable({
  providedIn: 'root',
})
export class ProductValidationsService {
  apiUrl = environment.apiUrl;

  private headers = getHttpHeaders();

  constructor(private http: HttpClient, private cookieService: CookieService) {}

  public startWorkflow(): Observable<CustomResponseDto<InitialProductValidationResponse>> {
    const data = {
      productType: '2',
      //productType: 'RAPIPLAZO',
      term: this.cookieService.get('term') || sessionStorage.getItem('term') || TERM_BY_DEFAULT_CONSTANT,
      amount: this.cookieService.get('amount') || sessionStorage.getItem('amount') || AMOUNT_BY_DEFAULT_CONSTANT,
      newLoan: this.cookieService.get('isNewLoan') || sessionStorage.getItem('isNewLoan'),
      infoAllianceIdEncrypted: sessionStorage.getItem('cai') || '',
      utm: this.cookieService.get('utm'),
    };

    return this.http.post(this.apiUrl + routes.productValidationsStartWorkFlow, data, { headers: this.headers }).pipe(
      map((response: CustomResponseDto<InitialProductValidationResponse>) => {
        return response;
      })
    );
  }
}
